module.exports = __webpack_public_path__ + "img/portugal.ec536776.svg";